module.exports = __webpack_public_path__ + "img/amazingBox.d088f2fa.png";